import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SecurityAppAIConfig } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { AI_CONFIGURATION_QUERY_STRING } from "ai/hooks/useAIConfiguration";
const enableAIReport = () => SecurityAppAIConfig.enableAI();
const disableAIReport = () => SecurityAppAIConfig.disableAI();
const useEnableAIReportMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: enable } = useMutation({
    mutationFn: enableAIReport,
    onSuccess: () => {
      UserNotification.success("Configuration updated successfully.");
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(`Configuration update failed with error: ${error}.`);
    }
  });
  const { mutateAsync: disable } = useMutation({
    mutationFn: disableAIReport,
    onSuccess: () => {
      UserNotification.success("Configuration updated successfully.");
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(`Configuration update failed with error: ${error}.`);
    }
  });
  return {
    enable,
    disable
  };
};
export default useEnableAIReportMutation;
